import { fromJS } from 'immutable';
import { EMPTYOBJECTSTATE_SET } from '../constants/actionTypes';

const initialState = fromJS({});

export function emptyobjectstate(state = initialState, { type, payload }) {
  switch (type) {
    case EMPTYOBJECTSTATE_SET:
      return state.set(payload.key, payload.value);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/emptyobjectstate.js